<template>
  <span :class="['icon-db', row[col.field] ? 'is-true' : 'is-false']"/>
</template>

<script>
export default {
  name: 'TemplateBoolean',
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    template: { type: Object, required: true }
  }
}
</script>
